export class SubscriptionStatsModel{
  trialing: number;
  paid: number;
}

export class SubscriptionModel {
  stats: SubscriptionStatsModel;
  isLoading: boolean;
}
